<template>
  <div>
    <el-row>
      <h5>产品：{{ 产品名称 }}</h5>
    </el-row>
    <el-row>
      <el-col :span="3" style="margin-top:20px" v-for="(item, index) in QUALIFICATION" :key="index">
        <el-card :body-style="{ padding: '0px' }" style="margin-left:10px"><img :src="'https://service.linkda.com.cn/file/' + item.URL" class="image" style="height:200px"
               v-if="getType(item) == 1">
          <img :src="pdfImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px"
               v-else-if="getType(item) == 2">
          <img :src="wordImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px"
               v-else-if="getType(item) == 3">
          <img :src="unknowImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px" v-else>
          <div style="padding: 14px;">
            <div class="bottom clearfix">
              <div>
                <span style="font-size:10px">资质名称：{{ item.NAME }}</span>
              </div>
              <el-button size="medium" type="text" class="button" @click="openImage(item)" v-if="getType(item) == 1">查看大图</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <img :src="this.imgUrl" style="width:100%">
    </el-dialog>
    <el-row>
      <el-col>
        <el-dialog :visible.sync="addFormDialog" title="上传资质凭证" @close="addFormDialog = false" width="400px" center>
          <el-form ref="addForm" v-model="addForm">
            <el-form-item label="资质名称：" :label-width="formLableWidth" style="margin-left:-40px">
              <el-input v-model="addForm.NAME" style="width:250px"> </el-input>
            </el-form-item>
            <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :name="this.addForm.image"
                       :multiple="false" :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form>
          <div slot="footer" style="text-align: center;">
            <el-button class="operate-btn" @click="closeaddForm">取消</el-button>
            <el-button class="operate-btn" @click="submitAdd">确认</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      addFormDialog: false,
      addForm: {
        image: 'qualification',
        NAME: '',
      },
      formLableWidth: '120px',
      file_name: '',
      fileList: [],
      送货日期: sessionStorage.getItem('送货日期'),
      产品编码: sessionStorage.getItem('产品编码'),
      产品名称: sessionStorage.getItem('产品名称'),
      QUALIFICATION: [],
      url: '',
      资质ID: Number(sessionStorage.getItem('资质ID')),
      dialogVisible: false,
      imgUrl: '',
      pdfImage: require('../../assets/common/image/404_images/pdf.png'),
      wordImage: require('../../assets/common/image/404_images/word.png'),
      unknowImage: require('../../assets/common/image/404_images/unknow.png'),
    };
  },
  methods: {
    queryContract() {
      const data = {
        SERVICE_ID: '10046',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        QUALIFY_ID: this.$route.params.id,
      };
      http.post(data).then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    queryData() {
      const data = {
        SERVICE_ID: '10035',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SPQ_ID: this.资质ID,
      };
      http.post(data).then((result) => {
        this.QUALIFICATION = result;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    getType(item) {
      if (String(item.URL).includes('jpg')) {
        //   if(String(item.URL).includes('png')){
        return 1;
      }
      if (String(item.URL).includes('png')) {
        return 1;
      }
      if (String(item.URL).includes('gif')) {
        return 1;
      } if (String(item.URL).includes('dib')) {
        return 1;
      } if (String(item.URL).includes('docx')) {
        return 3;
      }
      if (String(item.URL).includes('doc')) {
        return 3;
      } if (String(item.URL).includes('pdf')) {
        return 2;
      }
      return 4;
    },
    deleteImg(item) {
      const NEW_QUALIFICATION = this.QUALIFICATION.filter((itemt) => itemt.URL !== item.URL);
      const PRODUCT_CODE = [];
      PRODUCT_CODE.push(this.QUALIFICATION_CODE);
      const data = {
        SERVICE_ID: '10035',
        OTYPE: 5,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: this.送货日期,
        FILE_NAME: NEW_QUALIFICATION,
        PRODUCT_CODE,
      };
      http.post(data).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.资质ID = result[0].SPQ_ID;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openAdd() {
      this.addFormDialog = true;
    },
    openImage(e) {
      const URL = e.URL;
      this.dialogVisible = true;
      // this.imgUrl = 'http://106.15.250.223/file/'+URL
      // this.imgUrl = 'http://101.132.129.64/file/'+URL
      this.imgUrl = `https://service.linkda.com.cn/file/${URL}`;
    },
    downLoad(e) {
      const URL = e.URL;
      // window.location.href = 'http://106.15.250.223/file/'+URL
      // window.location.href = 'http://101.132.129.64/file/'+URL
      window.location.href = `https://service.linkda.com.cn/file/${URL}`;
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
      this.file_name = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    closeaddForm() {
      this.addFormDialog = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    submitAdd() {
      let FILE_NAME = [];
      FILE_NAME = this.fileList.map((item) => {
        FILE_NAME.push(item.response.file_name);
        return { NAME: this.addForm.NAME, URL: `${this.addForm.image}/${item.response.file_name}` };
      });
      const NEW_FILE_NAME = this.QUALIFICATION.concat(FILE_NAME);
      const PRODUCT_CODE = [];
      PRODUCT_CODE.push(this.产品编码);
      if (this.fileList.length == 0) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 5,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: this.送货日期,
        FILE_NAME: NEW_FILE_NAME,
        PRODUCT_CODE,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '上传成功', type: 'success' });
        this.资质ID = result[0].SPQ_ID;
        this.queryData();
        this.fileList = [];
        this.addForm.NAME = '';
        this.addFormDialog = false;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
  created() {
    this.queryData();
  },
};
</script>
<style>
.image {
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/components/foodSecurity/viewQualificatDetail.vue